<script> 
export default {
    name: "ViewDischargeSummary",

    data() {

        return {
            editDischarge: false,
            doctorsNurses: [],
            doctorname:'-',
            prescriptionDate:window.moment().format(`YYYY-MM-DD`),
        };
    },

    props: {

        patient: Object,
        showModal: Boolean,
        dischargeSummary: Object,
        doctors: Array,
        medicalreportdetails: Object
    },

    methods: {

        fetchConsultants() {
          return this.$http
            .get(`Shared/GetActiveConsultants`)
            .then(({ data }) => {
              this.doctorsNurses = data;
            })
            .catch(() => {});
        },

        printDischargeSummary() {
            let url = `/admissions/discharge-summary`;
                url += `?patientID=${this.dischargeSummary.patientID}`;
                url += `&visitNo=${this.dischargeSummary.visitNo}`;

            window.open(url, 
                '_blank', 
                `DischargeSummaryPrint`,);
        },
        printMedicalReport() {
        let url = `/med-f-print/medical-report/print`;
            url += `/${this.medicalreportdetails.patienT_ID}/${this.medicalreportdetails.visitNo}/${this.doctorname}/${this.prescriptionDate}`;

        window.open(url, '_blank', `Medical Report`,);
    },
    },

    
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-2/3 w-11/12">
  <template v-slot:title>
    <h5 class="font-medium text-sm">Medical Report</h5>
  </template>
  <template v-slot:modal-body>
    <div class="flex flex-wrap items-center">
        <div class="w-full flex flex-wrap border-2 border-gray-400 mb-2 rounded-t-md">
            <div class="w-full p-1 bg-gray-400 rounded-t-md">
                <h5 class="font-medium text-sm">Patient Details</h5>
            </div>
            <div class="w-full p-1">
                <h5 class="font-bold text-sm">
                    Name: {{ medicalreportdetails.names }}</h5>
            </div>
            <div class="md:w-1/3 w-1/2 p-1">
                <h5 class="font-bold text-sm">
                    MRN: {{ medicalreportdetails.patienT_ID }}</h5>
            </div>
            <div class="md:w-1/3 w-1/2 p-1">
                <h5 class="font-bold text-sm">
                    IP: {{ medicalreportdetails.ipfileno }}</h5>
            </div>
            <div class="md:w-1/3 w-1/2 p-1">
                <h5 class="font-bold text-sm">
                    OP: {{ medicalreportdetails.opfileno || `-` }}</h5>
            </div>
            <div class="md:w-1/3 w-1/2 p-1">
                <h5 class="font-bold text-sm">
                    DOB: {{ medicalreportdetails.dob | dateFormat }}</h5>
            </div>
            <div class="md:w-1/3 w-1/2 p-1">
                <h5 class="font-bold text-sm">
                    Age: {{ medicalreportdetails.age || `-` }} Yr(s)</h5>
            </div>
            <div class="md:w-1/3 w-1/2 p-1">
                <h5 class="font-bold text-sm">
                    Gender: {{ medicalreportdetails.gender }}</h5>
            </div>
        </div>
        <div class="w-full flex flex-wrap content-start">
            <!-- v-for="dS in medicalReportFile.patientVisitDetail.filter(dS => dS.visitNo == $route.params.visitNo)" :key="dS.id"> -->
               
                <div class="w-1/2 flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Past Medical History</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        <span v-html="medicalreportdetails.historyofIllness || `-`"></span>  
                    </div> 
                    <!-- <div class="w-full text-sm p-1">
                        <span v-html="dS.diagnosisOnAdmission || `-`"></span>
                    </div> -->
                </div>
                <div class="w-1/2 flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Medical Issues Arising/Diagnosis</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                     
                        <span v-html="medicalreportdetails.diagnosisOnOP || `-`"></span>  
                        <!-- <span v-html="dS.diagnosis || `-`"></span> -->
                    </div>
                </div>
                <div class="w-full flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Major Complaints</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        <span v-html="medicalreportdetails.chiefComplain || `-`"></span>
                       
                    </div>
                </div>
                <div class="w-full flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">On Examination</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        <span v-html=" medicalreportdetails.physicalExam || `-`"></span>
                    </div>
                </div>
                <div class="w-full flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Vitals</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        <span v-html="medicalreportdetails.patientVitals || `-`"></span>
                        
                    </div>
                </div>
                 <div class="w-full flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Investigations Done</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                       
                         <span v-html="medicalreportdetails.investigations || `-`"></span>
                       
                    </div>
                </div>
                <div class="w-full flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Procedures done</h5>
                    </div>
                    <div class="w-full text-sm p-1"> 
                        <span class="my-1" v-html="medicalreportdetails.procedures || `-`"></span>
                    </div>
                </div>
                <div class="w-full flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Drugs Received</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        
                        <span v-html="medicalreportdetails.drugs || `-`"></span>
                    </div>
                </div>
                <!-- <div class="w-1/2 flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Progress</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        <span v-html="dS.progress || `-`"></span>
                    </div>
                </div> -->
             
                <div class="w-full flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Treatment/Plan of Management</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        <!-- {{ medicalReportFile.managementNotes[0].managementNotes }} -->
                        <span v-html="medicalreportdetails.managementNotes || `-`"></span>
                    </div>
                </div>  
                <div class="w-1/2 flex flex-wrap content-start">
                    <div class="md:w-1/2 sm:w-1/2 p-tiny">
                        <div class="w-full p-1">
                        <h5 class="font-medium text-base">Doctor</h5>
                    </div>
          <v-select
            class="bg-white text-xs"
            :options="doctors"
            :reduce="(doc) => doc.names"
            label="names"
            v-model="doctorname"
          />
        </div>
                </div>
                <div class="w-1/2 flex flex-wrap content-start">
                    <div class="md:w-1/2 sm:w-full p-tiny">
                        <div class="w-full p-1">
                        <h5 class="font-medium text-base">Date</h5>
                    </div>
                <input type="date" v-model.trim="prescriptionDate" 
                    id="grid-date" class="input-control input-sm text-xs">
            </div>
                </div>
                <!-- <div class="w-full flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Comment</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        <span v-html=" medicalReportFile.diagnosisOnAdmission || `-`"></span>
                    </div>
                </div> -->
            </div>
            <div class="w-full flex flex-wrap p-1">
                <div class="flex-1">
                    
                </div>
                <div class="flex-1">

                </div>
                <div class="flex-1">

                </div>
                <div class="flex-1">
                    <!-- <button 
                        @click.prevent="() => {
                            fetchDischargeAllDetails().then(() => {
                                viewDischargeSummary = true;
                            }).catch(() => {});
                        }"
                        class="btn-sm btn-info text-xs rounded">
                        <i class="fa fa-eye"></i> Preview
                    </button> -->
                    <!-- <preview-discharge-summary 
                        :showModal="viewDischargeSummary"
                        :patient="patient"
                        :medicalReportFile="{
                            ...medicalReportFile[0],
                        }"
                        :prescriptions="prescriptions"
                        :appointments="appointments"
                        @closeModal="viewDischargeSummary = false"
                    /> -->
                </div>
              
            </div>
       
       
    </div>
     
  </template>
  <template v-slot:modal-footer>
    <!-- <button
        @click.prevent="() => {
            $root.loading = true;
            fetchConsultants().then(() => {
                $root.loading = false;
                editDischarge = true;
            });
        }"
        class="btn-sm btn-warning text-xs rounded mr-6">
            <i class="fa fa-pen"></i> Edit Summary</button> -->
    <button 
        @click.prevent="printMedicalReport" 
        class="btn-sm btn-primary text-xs rounded mr-6">
            <i class="fa fa-print"></i> Print</button>
    <button 
        class="btn-danger btn-sm text-xs rounded" 
        @click="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
  </template>
</tail-modal>
</template>